import { toast } from 'sonner';
import { t } from '../../localization/t';

const DISCORD_BRAND = '#5865F2';
const TEXT_COLOR = '#a8b4ff';

const SIZE_PRESETS = {
  sm: { textCqw: 0.5625, iconCqw: 0.625, gapPx: 4, padX: 6, padY: 2 },
  md: { textCqw: 0.6875, iconCqw: 0.75, gapPx: 6, padX: 8, padY: 4 },
};

export default function DiscordHandlePill({
  handle,
  size = 'sm',
  withAt = false,
  chrome = 'pill',
  className = '',
  style: extraStyle,
}) {
  if (!handle) return null;
  const preset = SIZE_PRESETS[size] || SIZE_PRESETS.sm;
  const label = withAt ? `@${handle}` : handle;
  const isText = chrome === 'text';

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    navigator.clipboard.writeText(handle)
      .then(() => toast.success(t('Copied @{handle}. Paste in Discord search.', { handle })))
      .catch(() => toast.error(t('Could not copy to clipboard')));
  };

  const chromeStyle = isText
    ? { gap: preset.gapPx }
    : {
      gap: preset.gapPx,
      paddingInline: preset.padX,
      paddingBlock: preset.padY,
      background: 'rgba(88,101,242,0.12)',
      border: '1px solid rgba(88,101,242,0.3)',
    };

  return (
    <span
      role="button"
      tabIndex={0}
      title={t('Copy @{handle} to clipboard', { handle })}
      className={`inline-flex items-center ${isText ? '' : 'rounded'} transition-colors cursor-pointer max-w-full ${className}`}
      style={{ ...chromeStyle, ...extraStyle }}
      onMouseEnter={isText ? undefined : (e) => { e.currentTarget.style.background = 'rgba(88,101,242,0.2)'; }}
      onMouseLeave={isText ? undefined : (e) => { e.currentTarget.style.background = 'rgba(88,101,242,0.12)'; }}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handleClick(e);
      }}
    >
      <svg
        style={{ width: `${preset.iconCqw}cqw`, height: `${preset.iconCqw}cqw` }}
        viewBox="0 0 24 24"
        fill={DISCORD_BRAND}
        className="shrink-0"
        aria-hidden="true"
      >
        <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
      </svg>
      <span
        className="font-medium truncate"
        style={{ color: TEXT_COLOR, fontSize: `${preset.textCqw}cqw` }}
      >
        {label}
      </span>
    </span>
  );
}
